var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-product-tab"},[_c('div',{staticClass:"header row-between",class:[{ opened: _vm.opened }],on:{"click":_vm.toggle}},[_c('div',{staticClass:"s-20 w-500"},[_c('h2',[_vm._v(_vm._s(_vm.name))])]),(!_vm.opened)?_c('icon-plus'):_c('icon-minus')],1),(_vm.opened)?_c('div',{staticClass:"content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }